import styled from 'styled-components';

import { colors } from '../../../../../../contrib/ui';
import { GroupStyled } from './Group.styles';

interface IProps {
  isDraggingOver: boolean;
  isFull: boolean;
}

export const DraggableGroupStyled = styled(GroupStyled)<IProps>`
  .group-panel {
    background-color: ${({ isDraggingOver, isFull }) =>
      isDraggingOver ? (isFull ? colors.mainColor : colors.grey9b) : 'white'};

    .team-vs .team-vs,
    .single-vs .single-row .single-vs {
      opacity: 1;
      visibility: visible;
    }
  }
`;
